import { HelpTip } from '../TargetingHelp';

type ObjectiveRowProps = {
  icon: React.ReactNode;
  title: string;
  /** Shown beside the title, e.g. how many secondaries there are. */
  count?: number;
  help: string;
  description: string;
  children: React.ReactNode;
};

/**
 * One row of the Objectives card: title, tooltip and a one-line meaning on the left, the control on
 * the right. Below md the two stack, so the control keeps its full width on a phone.
 */
export const ObjectiveRow = ({ icon, title, count, help, description, children }: ObjectiveRowProps) => (
  <div className="border-line grid grid-cols-1 border-b last:border-b-0 md:grid-cols-[300px_minmax(0,1fr)]">
    <div className="flex flex-col gap-1 px-5 pt-5 md:pb-5">
      <div className="flex items-center gap-2">
        {icon}
        <h3 className="text-foreground m-0 text-body font-semibold">{title}</h3>
        {count !== undefined ? <span className="text-dim text-micro tabular-nums">{count}</span> : null}
        <HelpTip text={help} label={title.toLowerCase()} />
      </div>
      <p className="supporting m-0 pl-6">{description}</p>
    </div>
    <div className="flex flex-col gap-2 px-5 py-4 md:py-5 md:pl-0">{children}</div>
  </div>
);
